import { useEffect } from "react";
import { useForm } from "@inertiajs/react";
import StepForm from "@/pages/steps/step-form";
import { buildStepFormData, serializeStep } from "@/pages/steps/form-utils";
import { handleDrawerSuccess, hasArrayErrors } from "@/lib/drawer-submission";

export default function StepEditDrawer({ step, templates = [], errors = [], updatePath, onSuccess, onProcessingChange = null }) {
  const { data, setData, patch, processing, transform } = useForm(buildStepFormData(step));

  useEffect(() => {
    setData(buildStepFormData(step));
  }, [setData, step]);

  useEffect(() => {
    onProcessingChange?.(processing);
  }, [onProcessingChange, processing]);

  const submit = (event) => {
    event.preventDefault();
    transform(() => ({ step: serializeStep(data.step) }));
    patch(updatePath, {
      preserveScroll: true,
      onSuccess: (page) => handleDrawerSuccess(
        page,
        (props) => props.show_edit_step_drawer || hasArrayErrors(props, "edit_step_errors"),
        onSuccess
      )
    });
  };

  return (
    <StepForm
      data={data}
      setData={setData}
      templates={templates}
      errors={errors}
      processing={processing}
      onSubmit={submit}
      submitLabel="Gem ændringer"
      layout="drawer"
    />
  );
}
